import React, { useRef, useState } from 'react'

import { find } from 'lodash'

import { useParams, useHistory } from 'react-router-dom'

import useSnackbar from 'hooks/useSnackbar'

import GovernanceProjectNameDpoContext from 'contexts/GovernanceProjectNameDpoContext'
import JourneyWhiteLabelProvider from './JourneyWhiteLabelProvider'

import * as service from 'service'
import helpers from 'helpers'
import constants from 'constants/index'

const GovernanceProjectNameDpoProvider = ({ children }) => {
  const [loading, setLoading] = useState()
  const [governanceProjectTemplate, setGovernanceProjectTemplate] = useState()
  const [governanceProjectCompany, setGovernanceProjectCompany] = useState()
  const [principalDpo, setPrincipalDpo] = useState()
  const [substituteDpo, setSubstituteDpo] = useState()
  const [recaptcha, setRecaptcha] = useState()
  const { templateToken: governanceProjectTemplateToken, slug } = useParams()
  const history = useHistory()

  const recaptchaRef = useRef(null)

  const snackbar = useSnackbar()

  const resetRecaptcha = () => {
    if (recaptchaRef.current) recaptchaRef.current.reset()
    setRecaptcha(undefined)
  }

  const handleAcceptedRecaptcha = (token) => setRecaptcha(token)
  const disableRecaptcha = () => setRecaptcha(undefined)

  const openSnackbar = (message, variant = 'error', redirect = true) => {
    snackbar.open({ message, variant })
    if (redirect) {
      history.push(`/${slug}/`)
    }

    return false
  }

  const loadGovernanceProjectTemplate = async () => {
    try {
      setLoading(true)
      const response =
        await service.dponet.governanceProjectTemplate.getByToken({
          token: governanceProjectTemplateToken,
        })

      const template = response?.data?.governanceProjectTemplate
      if (
        template?.finished ||
        template?.currentStage?.kind !==
          constants.governanceProjectStages.NAME_DPO_STAGE
      ) {
        return openSnackbar(
          'Esse projeto já foi finalizado ou não está na etapa de nomeação do DPO.',
        )
      }
      setGovernanceProjectTemplate(template)
    } catch (error) {
      console.error('Error loading governance project template:', error)
      return openSnackbar(helpers.formatters.errorMessage(error))
    } finally {
      setLoading(false)
    }
  }

  const loadGovernanceProjectCompany = async (
    document = governanceProjectCompany?.company?.document,
  ) => {
    try {
      setLoading(true)
      const response =
        await service.dponet.governanceProjectTemplate.consultCompany({
          token: governanceProjectTemplateToken,
          cnpj: helpers.regex.onlyNumbersAndLetters(document),
        })

      const governanceProjectCompany = response?.data?.governanceProjectCompany
      const companyStages =
        governanceProjectCompany?.governanceProjectCompanyStages
      const nameDpoStage = find(
        companyStages,
        (stage) =>
          stage.governanceProjectTemplateStage.kind ===
          constants.governanceProjectStages.NAME_DPO_STAGE,
      )

      if (
        !!nameDpoStage &&
        !constants.governanceProjectStages.OPEN_STAGE_STATUSES.includes(
          nameDpoStage.status,
        )
      ) {
        return openSnackbar(
          'Essa etapa do projeto já foi respondida. Aguarde as próximas intruções.',
          'warning',
          false,
        )
      }

      setGovernanceProjectCompany(governanceProjectCompany)

      return governanceProjectCompany
    } catch (error) {
      console.error('Error loading governance project company:', error)
      openSnackbar(helpers.formatters.errorMessage(error))
    } finally {
      setLoading(false)
    }
  }

  return (
    <JourneyWhiteLabelProvider>
      <GovernanceProjectNameDpoContext.Provider
        value={{
          disableRecaptcha,
          governanceProjectCompany,
          governanceProjectTemplate,
          handleAcceptedRecaptcha,
          loading,
          principalDpo,
          recaptcha,
          recaptchaRef,
          resetRecaptcha,
          substituteDpo,
          loadGovernanceProjectCompany,
          loadGovernanceProjectTemplate,
          setGovernanceProjectTemplate,
          setLoading,
          setPrincipalDpo,
          setSubstituteDpo,
        }}
      >
        {children}
      </GovernanceProjectNameDpoContext.Provider>
    </JourneyWhiteLabelProvider>
  )
}

export default GovernanceProjectNameDpoProvider
